
export default {
    props: {
        steppers: {
            type: Number,
            default: 1,
        },
        step1: {
            type: String,
            default: '',
        },
        step2: {
            type: String,
            default: '',
        },
    },
}
